export const MFA_CODE_LENGTH = 6;

export const MFA_RESEND_COOLDOWN_SECONDS = 80;

export const MFA_MAX_ATTEMPTS = 5;

export const MS_PER_SECOND = 1000;

export const MFA_PENDING_TTL_MS = 15 * 60 * MS_PER_SECOND;

export const MFA_ERROR_CODES = {
  INVALID_CODE: 'MFA_CODE_INVALID',
  SERVICE_UNAVAILABLE: 'MFA_SERVICE_UNAVAILABLE',
  TOO_MANY_REQUESTS: 'MFA_TOO_MANY_REQUESTS',
  NOT_AUTHENTICATED: 'NOT_AUTHENTICATED',
} as const;

export const MFA_ERROR_MESSAGE_KEYS: Readonly<Record<string, string>> = {
  [MFA_ERROR_CODES.INVALID_CODE]: 'LOGIN.MFA.ERRORS.INVALID_CODE',
  [MFA_ERROR_CODES.SERVICE_UNAVAILABLE]: 'LOGIN.MFA.ERRORS.SERVICE_UNAVAILABLE',
  [MFA_ERROR_CODES.TOO_MANY_REQUESTS]: 'LOGIN.MFA.ERRORS.TOO_MANY_REQUESTS',
  [MFA_ERROR_CODES.NOT_AUTHENTICATED]: 'LOGIN.MFA.ERRORS.SESSION_EXPIRED',
};

export const MFA_TRANSIENT_ERRORS: ReadonlySet<string> = new Set([
  MFA_ERROR_CODES.SERVICE_UNAVAILABLE,
  MFA_ERROR_CODES.TOO_MANY_REQUESTS,
]);

const VISIBLE_NAME_CHARS = 2;
const MASK = '*****';

export function maskEmail(email: string): string {
  const [name, domain] = email.includes('@') ? email.split('@') : [email, ''];
  const masked = `${name.slice(0, VISIBLE_NAME_CHARS)}${MASK}`;

  return domain ? `${masked}@${domain}` : masked;
}
